export enum BrazeEvents {
  CARE_ADD_TO_CART = "care_add_to_cart",
  CARE_CREATE_CHECKOUT = "care_create_checkout",
  CARE_VIEW_PAGE = "care_view_page",
}

// Define property keys as constants
export enum BrazeEventPropertyKeys {
  TEST_HASH = "testHash",
  TEST_TYPE = "testType",
  LAB_ORDER_UID = "labOrderUid",
  IS_LDT = "isLdt",
  CONSULT_UID = "consultUid",
  CONSULT_TYPE = "consultType",
  PURCHASE_TYPE = "purchaseType",
  SELECTED_TREATMENTS = "selectedTreatments",
  SELECTED_BUNDLE_TREATMENTS = "selectedBundleTreatments",
  ANTIBIOTIC_ELIGIBLE = "antibioticEligible",
  TREATMENT_PATHWAY_SLUG = "treatmentPathwaySlug",
  HAS_FERTILITY_INSIGHTS = "hasFertilityInsights",
  COACHING_CALL_STATUS = "coachingCallStatus",
  ELIGIBLE_TREATMENT_SKUS = "eligibleTreatmentSkus",
}

// Define property types for each event
export interface BrazeEventProperties {
  [BrazeEventPropertyKeys.TEST_HASH]?: string;
  [BrazeEventPropertyKeys.TEST_TYPE]?: string;
  [BrazeEventPropertyKeys.LAB_ORDER_UID]?: string;
  [BrazeEventPropertyKeys.IS_LDT]?: boolean;
  [BrazeEventPropertyKeys.CONSULT_UID]?: string;
  [BrazeEventPropertyKeys.CONSULT_TYPE]?: string;
  [BrazeEventPropertyKeys.PURCHASE_TYPE]?: string;
  [BrazeEventPropertyKeys.SELECTED_TREATMENTS]?: string[];
  [BrazeEventPropertyKeys.SELECTED_BUNDLE_TREATMENTS]?: string[];
  [BrazeEventPropertyKeys.ANTIBIOTIC_ELIGIBLE]?: boolean;
  [BrazeEventPropertyKeys.TREATMENT_PATHWAY_SLUG]?: string;
  [BrazeEventPropertyKeys.HAS_FERTILITY_INSIGHTS]?: boolean;
  [BrazeEventPropertyKeys.COACHING_CALL_STATUS]?: string;
  [BrazeEventPropertyKeys.ELIGIBLE_TREATMENT_SKUS]?: string[];
}
